import { render } from "./WebsitesView.vue?vue&type=template&id=bfda4118"
import script from "./WebsitesView.vue?vue&type=script&lang=js"
export * from "./WebsitesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__